import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';
import {
  deleteData,
  recordFiltering,
  findData,
} from '~/store/modules/modeloEquipamento/actions';

import MyForm from './form';

function ModeloEquipamento() {
  const redux = useSelector((state) => state.modeloEquipamento);

  const header = useMemo(
    () => [
      { id: 'mode_descricao', label: 'Modelo', filter: { type: 'text' } },
      { id: 'mode_vazao_maxima', label: 'Vazão Máxima (L/min)' },
      {
        id: 'mode_st_reg',
        label: 'Status',
        formatted: (value) => (value === 'S' ? 'Ativo' : 'Inativo'),
      },
    ],
    []
  );

  return (
    <UnidataTable
      fixed
      header={header}
      read={recordFiltering}
      remove={deleteData}
      find={findData}
      form={MyForm}
      redux={redux}
      title="Modelo Equipamento"
      detach="mode_cod_mode"
      keys={['mode_cod_mode']}
    />
  );
}

export default ModeloEquipamento;
